import React, { useState } from "react";
import { Form, Modal, Spinner } from "react-bootstrap";

const AddQueryCustomValueModal = ({
  Show,
  Hide,
  setCustomValue,
  customValue,
  setCustomType,
  customType,
  setQuery,
  query,
}) => {
  const [buttonLoader, setButtonLoader] = useState(false);
  const addNewQueryCustomValue = (customType, customValue) => {
    setButtonLoader(true);
    const newOption = {
      id: Math.floor(1000000000 + Math.random() * 9000000000),
      type: "customValue",
      valueType: customType,
      value: customValue || "",
    };
    let updatedQuery = [...query];
    if (newOption) {
      setQuery([...updatedQuery, newOption]);
      setCustomValue("");
      Hide();
    }
    setButtonLoader(false);
  };
  return (
    <>
      <Modal show={Show} onHide={Hide} backdrop="static" keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>Add Custom Value</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Value Type{" "}
              <abbr title="required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Select
              onChange={(e) => {setCustomType(e.target.value); setCustomValue("SCREENINGDATE")}}
              className="br3"
              style={{ fontSize: 12 }}
            >
              <option selected={customType === ""} value="">
                Select Type
              </option>
              <option selected={customType === "text"} value="text">
                Text
              </option>
              <option selected={customType === "number"} value="number">
                Number
              </option>
              <option selected={customType === "date"} value="date">
                Date
              </option>
              <option selected={customType === "time"} value="time">
                Time
              </option>
              <option selected={customType === "subjectScreeningDate"} value="subjectScreeningDate">Subject Screening Date</option>
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Custom Value{" "}
              <abbr title="required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              onChange={(e) => setCustomValue(e.target.value)}
              value={customValue}
              className="br3"
              placeholder="Custom Value"
              disabled={customType === "subjectScreeningDate" ? true : !customType}
              type={customType}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className="p-1 px-3 bg-light">
          <button
            className="updateProfile"
            style={{ fontSize: 12 }}
            disabled={!customValue || !customType || buttonLoader}
            onClick={() => addNewQueryCustomValue(customType, customValue)}
          >
            {buttonLoader ? (
              <div className="hstack gap-2">
                <Spinner size="sm"/> Adding...
              </div>
            ) : (
              "Add New"
            )}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AddQueryCustomValueModal;
